import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v3/admin/organizations_add/`;
export const Csrf = () => `/api/v3/admin/token/`;
export declare const QueryKey: never;
export type Payload = {
    name: string;
    licenseIds?: string[];
    usersLimit: number;
    domains: string[];
    authorizeUrl: string;
    accessTokenUrl: string;
    userDataUrl: string;
    scope: string[];
    clientId: string;
    clientSecret: string;
    isActive: boolean;
};
export type Response = Models.Organizations.Organization;
